import type { Section } from "vanilla-cookieconsent";

export enum CookieCategory {
  ANALYTICS = "analytics",
  FEATURES = "features",
  NECESSARY = "necessary",
}

export const sections: Section[] = [
  {
    description:
      "Indispensables pour le bon fonctionnement de notre site internet",
    linkedCategory: CookieCategory.NECESSARY,
    title:
      'Cookies strictement nécessaires <span class="pm__badge">Toujours activés</span>',
  },
  {
    linkedCategory: CookieCategory.FEATURES,
    title: "Cookies de fonctionnalités",
  },
  {
    linkedCategory: CookieCategory.ANALYTICS,
    title: "Cookies analytiques",
  },
];
